import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=3b994206&"
import script from "./Investigation.vue?vue&type=script&lang=js&"
export * from "./Investigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports